import axios from 'axios'
import { apiUrl, defaultApiUrl } from '@/store/region'

// 리전 목록 (선택 전이므로 항상 기본 서버로 요청)
export const regionList = async () => {
  return await axios.get(`${defaultApiUrl()}/server/region`)
}

export const userlogin = async (data) => {
  return await axios
    .post(`${apiUrl()}/users/login/webgl`, data, {
      credentials: true
    })
    .catch((err) => {
      return err.response
    })
}

export const userinfo = async (token) => {
  return await axios.get(`${apiUrl()}/users`, {
    headers: {
      Authorization: token
    }
  })
}

export const userfirstlogin = async (token) => {
  return await axios.get(`${apiUrl()}/users/first-login`, {
    headers: {
      Authorization: token
    }
  })
}

export const userwearing = async (token) => {
  return await axios.get(`${apiUrl()}/games/wearing`, {
    headers: {
      Authorization: token
    }
  })
}

export const userpasswordchange = async (token, data) => {
  return await axios.post(`${apiUrl()}/users/password/webgl`, data, {
    headers: {
      Authorization: token
    }
  })
}

export const usernicknamecheck = async (token, data) => {
  return await axios.post(`${apiUrl()}/users/nickname/check`, data, {
    headers: {
      Authorization: token
    }
  })
}

export const usernicknamechange = async (token, data) => {
  return await axios.put(`${apiUrl()}/users/nickname`, data, {
    headers: {
      Authorization: token
    }
  })
}

export const setuserfirstlogin = async (token) => {
  return await axios.get(`${apiUrl()}/users/firstloginset`, {
    headers: {
      Authorization: token
    }
  })
}

export const schoolSearch = async (data) => {
  return await axios.get(`${apiUrl()}/schools/name/check/${data}`)
}

export const schoolSearchByCode = async (data) => {
  return await axios.get(`${apiUrl()}/schools/code/check/${data}`)
}
